import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker-cssmodules.min.css'

import Input from '@hixme-ui/input'

const Datepicker = ({ onChange, input, ...restProps }) => (
  <DatePicker
    customInput={input || <Input />}
    dateFormat="MM/DD/YYYY"
    placeholderText="mm/dd/yyyy"
    onChange={onChange}
    {...restProps}
  />
)

Datepicker.displayName = 'hui:Datepicker'

Datepicker.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.object,
}

Datepicker.defaultProps = {
  onChange: () => null,
  selected: {},
}

export default Datepicker
